import { createContext, useContext, useMemo, useState, useSyncExternalStore, type ReactNode } from "react";
import { PreferencesStore, type UserPreferences } from "./preferencesStore";

const PreferencesContext = createContext<PreferencesStore | null>(null);

function safeLocalStorage(): Storage | null {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

export function PreferencesProvider({ children }: { children: ReactNode }) {
  const [store] = useState(() => new PreferencesStore(safeLocalStorage()));
  const value = useMemo(() => store, [store]);
  return <PreferencesContext.Provider value={value}>{children}</PreferencesContext.Provider>;
}

export function usePreferencesStore(): PreferencesStore {
  const store = useContext(PreferencesContext);
  if (!store) throw new Error("usePreferencesStore fuera de PreferencesProvider");
  return store;
}

export function usePreferences(): { prefs: UserPreferences; store: PreferencesStore } {
  const store = usePreferencesStore();
  const prefs = useSyncExternalStore(store.subscribe, store.getSnapshot);
  return { prefs, store };
}

